import {
  Org3 as Icon
} from 'components/icons';

export const meta = {
  id: 'Orgs',
  title: 'Organizations',
  category: 'Settings',
  exposes: [
    {
      title: 'Manage organizations',
      action: { module: 'Orgs', props: {} },
      // desription: 'general-settings-desc',
    },
    {
      title: 'New',
      action: { module: 'OrgsDetails', props: { context: 'add' } },
    },
    {
      title: 'Edit',
      action: { module: 'OrgsDetails', props: { context: 'edit' } },
    },
    {
      title: 'Members',
      action: {
        module: 'OrgsDetails', props: { context: 'edit', tab: 'Members' }
      },
    },
    {
      title: 'Products',
      action: {
        module: 'OrgsDetails', props: { context: 'edit', tab: 'Products' }
      },
    },
    {
      title: 'Tenants',
      action: {
        module: 'OrgsDetails', props: { context: 'edit', tab: 'Products' }
      },
    },
    {
      title: 'Switch',
      action: {
        module: 'Scopes', props: {}
      },
    },
  ],
  unique: false,
  icon: Icon,
  version: '1.0.0',
  description: `The ORG crud component`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 750,
    height: 500
  }
};
